// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import createReducer from '../../../../../../../store/createReducer';
import * as types from './actionTypes';

const initialState = {
  profile: {
    Token: null,
    CustomerId: null,
    Title: null,
    PaymentTypeId: null,
    ForeName: null,
    SurName: null,
    EmailID: null,
    Deleted: false,
    Blocked: false,
    Mobile: null,
    NewsLetter: false,
    PaymentType: 2,
    TradeCustomer: 0,
    IsBookshop: null,
    address: {
      AddressLine1: null,
      AddressLine2: null,
      Town: null,
      Postcode: null,
      County: null,
    },
    paypal: {
      PaypalEmail: null,
    },
    bank: {
      AccountName: null,
      AccountNumber: null,
      SortCode: null,
    },
  },
  ConfirmPaypalEmail: null,
  isChangePaypalEmailFirstTime: true,
  changePassword: {
    Password: null,
    NewPassword: null,
    ConfirmPassword: null,
  },
  success: {
    status: null,
    profile: null,
    address: null,
    payment: null,
  },
  validatePaypalResult: {
    Succes: null,
    Message: null,
  }
};

const profileReducer = createReducer(initialState, {
  // eslint-disable-next-line no-unused-vars
  [types.PROFILE_REQUEST](state, action) {
    return {
      ...state,
    };
  },
  [types.PROFILE_REQUEST_SUCCESS](state, action) {
    return {
      ...state,
      profile: {
        ...state.profile,
        ...action.response,
      },
      ConfirmPaypalEmail: action.response.paypal.PaypalEmail,
    };
  },
  [types.PROFILE_FIELD_CHANGE](state, payload) {
    return {
      ...state,
      profile: Object.assign({}, state.profile, { [payload.field]: payload.value })
    };
  },
  [types.CHANGE_PASSWORD_FIELD](state, payload) {
    return {
      ...state,
      changePassword: Object.assign({}, state.changePassword, { [payload.field]: payload.value })
    };
  },
  [types.PROFILE_ERRORS_CHANGE](state, payload) {
    return {
      ...state,
      errors: Object.assign({}, state.errors, { [payload.field]: payload.error })
    };
  },
  // eslint-disable-next-line no-unused-vars
  [types.RESET_ERRORS_AND_SUCCESS](state, action) {
    return {
      ...state,
      errors: initialState.errors,
      success: initialState.success,
    };
  },
  [types.SET_SUCCESS](state, action) {
    return {
      ...state,
      success: action.data,
    };
  },
  // eslint-disable-next-line no-unused-vars
  [types.PROFILE_EDIT_REQUEST](state, action) {
    return {
      ...state,
      validatePaypalResult: {
        Succes: null,
        Message: null,
      },
    };
  },
  [types.ADDRESS_FIELD_CHANGE](state, payload) {
    return {
      ...state,
      profile: {
        ...state.profile,
        address: Object.assign({}, state.profile.address, { [payload.field]: payload.value }),
      },
    };
  },
  [types.PAYMENT_FIELD_CHANGE](state, payload) {
    return {
      ...state,
      profile: {
        ...state.profile,
        bank: Object.assign({}, state.profile.bank, { [payload.field]: payload.value }),
      }
    };
  },
  [types.PAYPAL_FIELD_CHANGE](state, payload) {
    return {
      ...state,
      profile: {
        ...state.profile,
        paypal: Object.assign({}, state.profile.paypal, { [payload.field]: payload.value }),
      }
    };
  },
  [types.CONFIRM_PAYPAL_FIELD_CHANGE](state, payload) {
    return {
      ...state,
      [payload.field]: payload.value === '' ? null : payload.value,
    };
  },
  [types.PROFILE_EDIT_REQUEST_SUCCESS](state, action) {
    return {
      ...state,
      success: {
        ...state.success,
        ...action.data,
      },
    };
  },
  [types.PROFILE_EDIT_REQUEST_FAILED](state, action) {
    return {
      ...state,
      success: {
        ...state.success,
        ...action.data,
      },
    };
  },
  // eslint-disable-next-line no-unused-vars
  [types.RESET_PASSWORD_CHANGES](state, action) {
    return {
      ...state,
      changePassword: initialState.changePassword,
    };
  },
  [types.PROFILE_EDIT_REQUEST_SUCCESS](state, action) {
    return {
      ...state,
      success: {
        ...state.success,
        ...action.data,
      },
    };
  },
  [types.PROFILE_EDIT_REQUEST_FAILED](state, action) {
    return {
      ...state,
      success: {
        ...state.success,
        ...action.data,
      },
    };
  },
  [types.VALIDATE_PAYPAL_EMAIL_REQUEST](state) {
    return {
      ...state,
      success: {
        status: null,
        profile: null,
        address: null,
        payment: null,
      },
    };
  },
  [types.VALIDATE_PAYPAL_EMAIL_REQUEST_SUCCESS](state, action) {
    return {
      ...state,
      validatePaypalResult: {
        ...action.response,
      },
    };
  },
  [types.SET_CONFIRM_PAYPAL_NULL](state, action) {
    return {
      ...state,
      ConfirmPaypalEmail: state.isChangePaypalEmailFirstTime ? null : state.ConfirmPaypalEmail,
      isChangePaypalEmailFirstTime: action.isChangeFirstTime,
    };
  },
  [types.SET_IS_CHANGE_FIRST_TIME](state, action) {
    return {
      ...state,
      isChangePaypalEmailFirstTime: action.isChangeFirstTime,
    };
  },
  [types.VERIFY_PHONE_NUMBER](state) {
    return {
      ...state,
    };
  },
  [types.VERIFY_PHONE_NUMBER_FAILED](state, action) {
    return {
      ...state,
      success: {
        ...state.success,
        ...action.data,
      },
    };
  },
  [types.VERIFY_BANK_ACCOUNT](state) {
    return {
      ...state,
    };
  },
  [types.VERIFY_BANK_ACCOUNT_FAILED](state, action) {
    return {
      ...state,
      success: {
        ...state.success,
        ...action.data,
      },
    };
  },
  [types.RESET_ADDRESS](state) {
    return {
      ...state,
      profile: {
        ...state.profile,
        address: initialState.address,
      }
    };
  },
});

export default profileReducer;
